import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import { strVal } from '../../../../modules/Utils'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'

function List(props) {
  const { lines, fetchingLines, fetchLines, isConfirmed, onShow } = props

  const columns = [
    {
      Header: 'ID',
      accessor: '_id',
      width: 150,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'No',
      accessor: 'no',
      width: 80,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },

    {
      Header: 'Name',
      accessor: 'name',
      style: { paddingLeft: 5, alignment: 'left' },
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Unit', accessor: 'unit', width: 80},
    { Header: 'UoM', accessor: 'uom.code', width: 80 },
    { Header: 'Rate', accessor: 'rate', width: 120, Cell: MoneyCell },
    { Header: 'Tax', accessor: 'tax.rate', width: 120, Cell: MoneyCell },
    {
      Header: 'Tax Type',
      accessor: 'tax.type',
      width: 80,
      hideable: true,
      hideDefault: false,
    },
    { Header: 'Sub-Total', accessor: 'amount.net', width: 120, Cell: MoneyCell },
    { Header: 'Tax', accessor: 'amount.tax', width: 80, Cell: MoneyCell },
    {
      Header: 'Total',
      accessor: 'amount.gross',
      width: 120,
      Cell: MoneyCell,
      Footer: SumFooter,
    },

    {
      Header: 'Account',
      accessor: 'account.name',
      width: 150,
      Cell: ({ value, original }) => value && `${strVal(original, 'account.code')} ${value}`,
    },
  ]

  return (
    <CustomTable
      data={lines}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetchingLines}
      fetch={fetchLines}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={isConfirmed}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
